import { typography } from './web/typography';
import createTheme from '@mui/material/styles/createTheme';
import { lightPalette } from './web/palettes';
import responsiveFontSizes from '@mui/material/styles/responsiveFontSizes';
import { getSharedComponents } from './web/lightThemeShared';

const theme = createTheme({
  palette: lightPalette,
  shape: {
    borderRadius: 4,
  },
  typography,
});

const shared = getSharedComponents(theme);

//@ts-ignore
theme.components = {
  ...shared,
};

export const lightTheme = responsiveFontSizes(theme);
